(function () {
  'use strict';

  angular.module('app').component('clientProfileSeasonDetail', clientProfileSeasonDetail());

  function clientProfileSeasonDetail() {
    return {
      bindings: {
        clientProfileSeason: '=',
        clientProfile: '=',
        mode: '=',
        priceLists: '=',
        onClientProfileSeasonSaved: '&',
        onClientProfileSeasonDeleted: '&',
        onClientProfileSeasonCanceled: '&',
      },
      controller: ClientProfileSeasonDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/client-profiles/components/client-profile-seasons/client-profile-season-detail/client-profile-season-detail.component.html',
    };
  }

  ClientProfileSeasonDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$filter',
    '$translate',
    'ClientProfileSeasonService',
    'ClientProfileProductCategorySettingService',
    'ClientProfileProductSettingService',
  ];

  function ClientProfileSeasonDetailComponent(
    config,
    UtilService,
    $filter,
    $translate,
    ClientProfileSeasonService,
    ClientProfileProductCategorySettingService,
    ClientProfileProductSettingService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    /*vm.generalOptions = [
            { name: $translate('GENERAL'),        icon: 'tag',        percentage_type: 'general_percentage',        min: 1, max: 100 },
            { name: $translate('TOUR'),           icon: 'binoculars', percentage_type: 'tour_percentage',           min: 0, max: 100 },
            { name: $translate('TRANSPORTATION'), icon: 'truck',      percentage_type: 'transportation_percentage', min: 0, max: 100 },
            { name: $translate('HOTEL'),          icon: 'building',   percentage_type: 'hotel_percentage',          min: 0, max: 100 }
        ];*/

    // vm.dateDisplay = config.DATE_DISPLAY;
    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      // console.log(vm.clientProfileSeason);
      setGeneralSettings(vm.clientProfileSeason.client_profile_general_settings);

      if (vm.clientProfileSeason.id) {
        // View/Edit
        setItemOptions();
      } else {
        // New
        vm.saveButtonLabel = 'SAVE_GENERAL_SETTINGS';
      }
    };

    // public methods
    // -----------------------
    vm.editClientProfileSeason = function () {
      vm.mode = 'edit';
    };

    // Save all settings for the client profile, for all price lists
    vm.saveClientProfileSeason = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;

        return;
      }

      let generalSettings = ClientProfileSeasonService.groupGeneralSettingsByPriceList(
        vm.generalSettings
      );

      let productCategorySettings =
        ClientProfileProductCategorySettingService.unGroupSettingsByProductCategory(
          vm.clientProfileSeason.client_profile_product_category_settings
        );

      let productSettings = ClientProfileProductSettingService.unGroupSettingsByProduct(
        vm.clientProfileSeason.client_profile_product_settings
      );

      let params = {
        id: vm.clientProfileSeason.id,
        client_profile_general_settings: generalSettings,
        client_profile_product_category_settings: productCategorySettings,
        client_profile_product_settings: productSettings,
        season_id: vm.clientProfileSeason.season_id,
      };

      //console.log(params); return;
      vm.sendingForm = true;
      ClientProfileSeasonService.saveClientProfileSeason(params, vm.clientProfile.id).then(
        function (response) {
          if (response) {
            // Success
            if (vm.mode === 'create') {
              // Refresh object
              vm.clientProfileSeason.id = response.id;
              vm.clientProfileSeason.status = response.status;

              setGeneralSettings(response.client_profile_general_settings);

              setItemOptions();
            }

            vm.mode = 'view';

            vm.onClientProfileSeasonSaved({ item: response });
          } else {
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        }
      );
    };

    vm.cancel = function () {
      vm.onClientProfileSeasonCanceled({ mode: vm.mode });
      vm.mode = 'view';
    };

    vm.saveGeneralSettings = function (generalSetting, isGeneralSettingFormValid) {
      vm.formErrors = false;

      if (!isGeneralSettingFormValid) {
        vm.formErrors = true;

        return;
      }

      if (generalSetting.editMode) {
        delete generalSetting.originalValues;
      }

      let generalSettings = generalSetting.settingsByPriceList;

      // console.log(generalSettings);
      // return;

      vm.sendingForm = true;
      ClientProfileSeasonService.saveGeneralSettings(
        generalSettings,
        vm.clientProfile.id,
        vm.clientProfileSeason.id
      ).then(function (response) {
        if (response) {
          // Success
          vm.UtilService.itemListChanged(generalSetting.name);

          generalSetting.editMode = false;
        } else {
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    };

    vm.toggleEditMode = function (setting) {
      setting.editMode = !setting.editMode;

      if (!setting.editMode) {
        _restoreOriginalValues(setting);
      } else {
        setting.originalValues = angular.copy(setting);
      }
    };

    vm.changeClientProfileSeasonStatus = function (clientProfileSeason) {
      ClientProfileSeasonService.changeClientProfileSeasonStatus(
        clientProfileSeason,
        vm.clientProfile.id
      );
    };

    vm.deleteClientProfileSeason = function (clientProfileSeason) {
      // var successCallback = function() {
      let successCallback = () => {
        vm.onClientProfileSeasonDeleted({ idSeasonDeleted: clientProfileSeason.id });
      };

      ClientProfileSeasonService.deleteClientProfileSeason(
        clientProfileSeason,
        vm.clientProfile.id,
        successCallback,
        {}
      );
    };

    vm.onProductCategorySettingsUpdated = function () {
      //console.log('onProductCategorySettingsUpdated'); // what to do from here?
    };

    vm.onProductSettingsUpdated = function () {
      //console.log('onProductSettingsUpdated'); // what to do from here?
    };

    // private methods
    // -----------------------
    function setItemOptions() {
      vm.saveButtonLabel = 'UPDATE_GENERAL_SETTINGS';
    }

    function setGeneralSettings(clientProfileGeneralSettings) {
      vm.generalSettings = ClientProfileSeasonService.setGeneralSettings(
        clientProfileGeneralSettings,
        vm.priceLists
      );
    }

    // Restore item original values - Edit mode
    function _restoreOriginalValues(setting) {
      setting.settingsByPriceList.forEach(function (priceListSetting) {
        setting.originalValues.settingsByPriceList.forEach(function (originalValue) {
          if (priceListSetting.id === originalValue.id) {
            priceListSetting[priceListSetting.percentage_type] =
              originalValue[priceListSetting.percentage_type];
            return;
          }
        });
      });
    }
  }
})();
